export const REGISTER_FAIL_EVENT = 'register_fail';
export const REGISTER_START_EVENT = 'register_start';
export const MARKETING_PREFERENCE_CHECKED = 'checked';
export const MARKETING_PREFERENCE_UNCHECKED = 'unchecked';
export const FAILED_REASON_VALIDATION_FAILED = 'Validation failed';
export const FAILED_REASON_EMAIL = 'Email already exists';
export const FAULT_MESSAGE_CREATE_SUBSCRIBER = 'code_113';
export const FAULT_CODE_EMAIL_ALREADY_EXISTS = '113';
